import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App.tsx';
import Impressum from './pages/Impressum.tsx';
import Datenschutz from './pages/Datenschutz.tsx';
import Kundenerstinfo from './pages/Kundenerstinfo.tsx';
import ScrollToTop from './components/ScrollToTop.tsx';
import SmoothScroll from './components/SmoothScroll.tsx';
import './index.css';
import './styles/animations.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <ScrollToTop />
      <SmoothScroll />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/kundenerstinfo" element={<Kundenerstinfo />} />
      </Routes>
    </Router>
  </StrictMode>
);